import { render, staticRenderFns } from "./UpdatePhoto.vue?vue&type=template&id=83225abc&scoped=true"
import script from "./UpdatePhoto.vue?vue&type=script&lang=js"
export * from "./UpdatePhoto.vue?vue&type=script&lang=js"
import style0 from "./UpdatePhoto.vue?vue&type=style&index=0&id=83225abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83225abc",
  null
  
)

export default component.exports